import cn from 'classnames';
import { Component, MouseEvent } from 'react';
import styles from 'components/Shared/Overlay/styles.scss';

const ANIMATION_DELAY = 200;

interface OwnState {
  className: string;
  exiting: boolean;
}
interface OwnProps {
  transparent?: boolean;
  onClick?: (e: MouseEvent<HTMLDivElement>) => void;
  isFilterOverlay?: boolean;
}
export class Overlay extends Component<OwnProps, OwnState> {
  public readonly state = {
    className: '',
    exiting: false
  };
  private timeout: number;

  public componentWillUnmount() {
    window.clearTimeout(this.timeout);
  }
  public componentWillEnter(cb: () => void) {
    this.setState(
      () => ({ className: styles.enter }),
      () => window.requestAnimationFrame(cb)
    );
  }

  public componentWillLeave(cb: () => void) {
    this.setState(
      () => ({ className: styles.exit }),
      () => (this.timeout = window.setTimeout(cb, ANIMATION_DELAY))
    );
  }

  public render() {
    return (
      <div
        onClick={this.onClick}
        className={cn(styles.overlay, this.state.className, {
          [styles.transparent]: this.props.transparent,
          [styles.filterOverlay]: this.props.isFilterOverlay
        })}
      />
    );
  }

  private onClick = (e: MouseEvent<HTMLDivElement>) => {
    if (!this.state.exiting) {
      this.setState(
        {
          exiting: true
        },
        () => this.props.onClick && this.props.onClick(e)
      );
    }
  };
}
